import { render, staticRenderFns } from "./SearchBoxWide.vue?vue&type=template&id=616f35c6&"
import script from "./SearchBoxWide.vue?vue&type=script&lang=js&"
export * from "./SearchBoxWide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports